/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable max-len */
import { ChevronRightIcon, InfoIcon } from 'lucide-react';
import SmartFilterIcon from '../../public/icons/smart-filter.svg';
import { Tooltip, TooltipContent, TooltipProvider, TooltipTrigger } from '../ui/tooltip';

type Props = {
  filter: string;
  handleFilterClick: (val: string) => void;
}

const SmartFilters = ({ filter, handleFilterClick}: Props) => {
  return (
    <div className='bg-[#F8FAFC] border border-[#E2E8F0] rounded-lg p-2 flex gap-2 items-center hover:cursor-pointer group'>
      <div className='flex items-center gap-1'>
        <SmartFilterIcon />
        <span className='text-xs font-medium'>Smart Filters</span>
      </div>
      <div className={`flex items-center ${filter === 'highintent-inprogress' ? 'max-w-[400px]' : 'max-w-0'} overflow-hidden whitespace-nowrap group-hover:max-w-[400px] transition-all duration-300`}>
        <div 
          className={`border ${filter === 'highintent-inprogress' ? 'border-secondary bg-secondary text-white' : 'border-[#E2E8F0] bg-[#F8FAFC] text-primary-dark'}  px-2 py-1.5 rounded-lg flex items-center gap-2 text-xs font-medium`}
          onClick={() => handleFilterClick(filter === 'highintent-inprogress' ? 'reset' : 'highintent-inprogress')}
        >
          High Intent - In Progress 
          <TooltipProvider delayDuration={300}>
            <Tooltip>
              <TooltipTrigger asChild>
                <InfoIcon className={`w-3.5 h-3.5 ${filter === 'highintent-inprogress' ? 'text-white' : 'text-primary-dark'}`}/>
              </TooltipTrigger>
              <TooltipContent
                align="center" 
                side='top' 
                className='w-[320px] bg-black p-2.5 rounded-lg text-xs font-bold text-white whitespace-normal'
              >
                Those conversations which include high intent and are in progress will be sorted out
              </TooltipContent>  
            </Tooltip>
          </TooltipProvider>
        </div>
      </div>
      <ChevronRightIcon className='w-5 h-5'/>
    </div>
  )
}

export default SmartFilters